/**
 * WMS Receiving Module Types
 * Shared between backend-wms and mobile-app
 *
 * DRY Compliance: Single source for all receiving-related enums
 */

/**
 * Status of a receiving order
 */
export enum ReceivingOrderStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

/**
 * Status of a receiving line
 */
export enum ReceivingLineStatus {
  PENDING = 'PENDING',
  PARTIALLY_RECEIVED = 'PARTIALLY_RECEIVED',
  FULLY_RECEIVED = 'FULLY_RECEIVED',
  OVER_RECEIVED = 'OVER_RECEIVED',
}

/**
 * Status labels for UI display
 */
export const ReceivingOrderStatusLabels: Record<ReceivingOrderStatus, string> = {
  [ReceivingOrderStatus.PENDING]: 'Pending',
  [ReceivingOrderStatus.IN_PROGRESS]: 'In Progress',
  [ReceivingOrderStatus.COMPLETED]: 'Completed',
  [ReceivingOrderStatus.CANCELLED]: 'Cancelled',
};

export const ReceivingLineStatusLabels: Record<ReceivingLineStatus, string> = {
  [ReceivingLineStatus.PENDING]: 'Pending',
  [ReceivingLineStatus.PARTIALLY_RECEIVED]: 'Partially Received',
  [ReceivingLineStatus.FULLY_RECEIVED]: 'Fully Received',
  [ReceivingLineStatus.OVER_RECEIVED]: 'Over Received',
};

/**
 * Color schemes for status badges (Chakra UI v3 compatible)
 */
export const ReceivingOrderStatusColors: Record<ReceivingOrderStatus, string> = {
  [ReceivingOrderStatus.PENDING]: 'gray',
  [ReceivingOrderStatus.IN_PROGRESS]: 'blue',
  [ReceivingOrderStatus.COMPLETED]: 'green',
  [ReceivingOrderStatus.CANCELLED]: 'red',
};

export const ReceivingLineStatusColors: Record<ReceivingLineStatus, string> = {
  [ReceivingLineStatus.PENDING]: 'gray',
  [ReceivingLineStatus.PARTIALLY_RECEIVED]: 'yellow',
  [ReceivingLineStatus.FULLY_RECEIVED]: 'green',
  [ReceivingLineStatus.OVER_RECEIVED]: 'orange',
};
